import React from 'react';

function BenefitsSection() {
    const benefits = [
        {
            icon: '🔗',
            title: 'One Partner, Multiple Services',
            description: 'Every service flows through one team. Guest feedback, booking data, staff performance, revenue metrics all managed by people who know your property inside and out.'
        },
        {
            icon: '🎯',
            title: 'No More Vendor Juggling',
            description: 'Stop managing seven agencies with seven contracts, seven invoices, seven support teams. One partner. One conversation. One invoice. One throat to choke.'
        },
        {
            icon: '🤝',
            title: 'Human-First Service',
            description: 'Real people managing your reputation, optimizing your listings, creating your content, and sourcing your candidates. Technology supports us, but people deliver.'
        },
        {
            icon: '⚡',
            title: 'Built for Hospitality',
            description: 'We\'re not a generic tech company. We\'re hospitality insiders who built services for hotels, by hoteliers. We speak your language: RevPAR, ADR, CSAT, GRI, compression nights.'
        },
        {
            icon: '📊',
            title: 'Coordinated Execution',
            description: 'Your dedicated team meets weekly to review performance across all services. OTA optimization informs content strategy. Review feedback shapes recruiting. Everything works together.'
        },
        {
            icon: '🚀',
            title: 'Proactive, Not Reactive',
            description: 'Stop firefighting. We monitor reviews daily, check rate parity constantly, and identify booking opportunities before your competitors do.'
        }
    ];

    return (
        <section className="benefits-section">
            <div className="section-content">
                <h2 className="section-title">Why <span className="highlight">Warp Mill</span> Changes Everything</h2>
                <div className="benefits-grid">
                    {benefits.map((benefit, index) => (
                        <div key={index} className="benefit-card">
                            <div className="benefit-icon">{benefit.icon}</div>
                            <h3 className="benefit-title">{benefit.title}</h3>
                            <p>{benefit.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default BenefitsSection;

